"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "open", "onClose", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sizes = {
  medium: "35rem",
  small: "28rem",
  tiny: "20rem"
};
var StyledDiv = (0, _material.styled)("div", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "size";
  }
})(function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "2px",
    boxShadow: theme.shadows[5],
    margin: "auto",
    outline: 0,
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)",
    width: sizes[size]
  };
});

var Modal = function Modal(_ref2) {
  var children = _ref2.children,
      open = _ref2.open,
      onClose = _ref2.onClose,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "medium" : _ref2$size,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Modal, _objectSpread(_objectSpread({
    onClose: onClose,
    open: open
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Fade, {
      in: open,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDiv, {
        size: size,
        children: children
      })
    })
  }));
};

var _default = Modal;
exports.default = _default;